import * as React from 'react';
import classnames from 'classnames';
import { Card } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { LoyaltyPoint } from '@grandvisionhq/fun-loyalty-points';
import { useIntl } from '@grandvisionhq/state';
import { useOrderDetails } from './hooks/use-order-details.js';
import { LocationInfo } from '../../../modules/LocationInfo/layout/LocationInfo.js';

const OrderDetailsSummary = ({ orderData , shippingMethodsAsides , labels ,  })=>{
    var ref;
    const { shippingMethodInfo , isPickupDelivery , pickupLocation , orderDetailsSummaries , features , showInvoiceDetails ,  } = useOrderDetails(orderData, shippingMethodsAsides, labels);
    const { company: CompanySummary , addresses: AddressesSummary , contactDetails: ContactDetailsSummary , invoice: InvoiceSummary ,  } = orderDetailsSummaries;
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "card--colapse-borders"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, labels.yourDetails), /*#__PURE__*/ React.createElement(Card, {
        className: "checkout-card__reset-bottom-border-radius"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head",
        className: "orderConfirm__card-caption"
    }, labels.shipmentDetailsTitle), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, shippingMethodInfo.label, " ", shippingMethodInfo.aside))), isPickupDelivery && pickupLocation && /*#__PURE__*/ React.createElement(LocationInfo, {
        location: pickupLocation
    }), AddressesSummary, showInvoiceDetails && /*#__PURE__*/ React.createElement(React.Fragment, null, InvoiceSummary), ((ref = orderData.billingAddress) === null || ref === void 0 ? void 0 : ref.company) && /*#__PURE__*/ React.createElement(React.Fragment, null, CompanySummary), ContactDetailsSummary, (features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && (orderData === null || orderData === void 0 ? void 0 : orderData.serviceStore) && /*#__PURE__*/ React.createElement(Card, {
        "data-t": "service-store-summary",
        className: classnames({
            'checkout-card__reset-top-border-radius': !orderData.loyaltyDetails,
            'checkout-card__reset-border-radius': orderData.loyaltyDetails
        })
    }, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head",
        className: "orderConfirm__card-caption"
    }, labels.serviceStoreTitle), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, orderData === null || orderData === void 0 ? void 0 : orderData.serviceStore.name), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, orderData === null || orderData === void 0 ? void 0 : orderData.serviceStore.streetName, " ", orderData === null || orderData === void 0 ? void 0 : orderData.serviceStore.streetNumber))), orderData.loyaltyDetails ? /*#__PURE__*/ React.createElement(Card, {
        "data-t": "loyalty-points-summary",
        className: "checkout-card__reset-top-border-radius"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head",
        className: "orderConfirm__card-caption"
    }, getLabel('checkout.overview.loyaltyPoints.heading')), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, getLabel('checkout.completed.loyaltyPoints.collected'), ":"), /*#__PURE__*/ React.createElement(LoyaltyPoint, {
        loyaltySymbol: getLabel('cart.loyalty.loyaltySymbol'),
        points: orderData.loyaltyDetails.points
    }), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, getLabel('cart.loyalty.saved.number'), ": ", orderData.loyaltyDetails.cardNumber))) : undefined);
};

export { OrderDetailsSummary };
//# sourceMappingURL=OrderDetailsSummary.js.map
